import OapToastNotification from './code/Scripts/components/OapToastNotification.vue';

export default {
  components: {
    OapToastNotification,
  },
};
